import { useEffect } from "react";
import { useDispatch } from "react-redux";
import socket from "../../utils/socketConnect.utils";

import { RootDispatch } from "../../store";
import { getUserId } from "../../utils/auth";
import {
  getTaskManagerNotifications,
  getTaskManagerUnreadNotificationCount,
  setTaskNotification,
} from "../../store/slices/taskmanagementSlice";

const TaskNotificationCountSocket = () => {
  const dispatch = useDispatch<RootDispatch>();
  const currentUserId = getUserId();

  useEffect(() => {
    if (!socket.connected) socket.connect();

    if (currentUserId) {
      socket.emit("join", { currentUserId });
    }

    if (currentUserId) {
      dispatch(getTaskManagerNotifications({ page: 1, limit: 10 }));
      dispatch(getTaskManagerUnreadNotificationCount(false));
    }
    socket.on("new-notification", (data) => {
      dispatch(setTaskNotification(data.notifications));
      dispatch(getTaskManagerUnreadNotificationCount(false));
    });
    return () => {
      socket.off("new-notification");
    };
  }, [dispatch, currentUserId]);

  return null;
};

export default TaskNotificationCountSocket;
